import state$1 from './shared/state.js';
export { useProps } from './shared/utils.js';
import { debugOn, debugOff } from './shared/debug.js';
export { afterChange } from './shared/pubSub.js';
export { batch, initStore } from './store.js';
export { default as collect } from './collect.js';
export { default as PropTypes } from './shared/propTypes.js';
var store = state$1.store; // `internals` is not part of the Recollect API. It is used by tests.

var internals = state$1;

if (typeof window !== 'undefined') {
  if ('Proxy' in window) {
    window.__RR__ = {
      debugOn: debugOn,
      debugOff: debugOff,
      internals: state$1
    };
  } else {
    console.warn("This browser doesn't support the Proxy object, which react-recollect needs. See https://caniuse.com/#search=proxy to find out which browsers do support it");
  }
}

export { internals, store };